import React, { useEffect, useState } from "react";

export default function AccountAndEnquirySummary({
  accountData,
  enquiryData,
  summary,
  employmentData,
}) {
  const data = enquiryData?.enquiries;

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const parts = dateString.split("+")[0].split("-");
    if (parts.length < 3) return dateString;
    const [year, month, day] = parts;
    return `${day}-${month}-${year}`;
  };

  const [accountStats, setAccountStats] = useState({
    accounts: {
      total: summary?.total_accounts || "N/A",
      overdue: summary?.total_overdue_accounts || "0",
      zeroBalance: summary?.total_zero_balance_accounts || "N/A",
    },
    advances: {
      highSanctionedAmt: summary?.total_sanctioned_amount || "N/A",
    },
    balances: {
      current: summary?.total_current_balance || "N/A",
      overdue: summary?.total_amount_overdue || "0",
    },
    openingDate: {
      recent: "N/A",
      oldest: "N/A",
    },
  });

  useEffect(() => {
    if (!accountData || accountData.length === 0) return;

    setAccountStats((prev) => ({
      ...prev,
      accounts: {
        total: summary?.total_accounts || accountData?.length || "N/A",
        overdue: summary?.total_overdue_accounts || "N/A",
        zeroBalance: summary?.total_zero_balance_accounts || "N/A",
      },
      openingDate: {
        recent: accountData?.[0]?.Tradeline?.dateOpened
          ? formatDate(accountData[0].Tradeline.dateOpened)
          : "N/A",
        oldest: accountData?.[accountData.length - 1]?.Tradeline?.dateOpened
          ? formatDate(accountData[accountData.length - 1].Tradeline.dateOpened)
          : "N/A",
      },
    }));
  }, [accountData, summary]);

  const totalEnquiries = data?.length || enquiryData?.totalEnquiries || "N/A";

  // Employment Fallback / Props
  const emp = employmentData || {
    accountType: "N/A",
    dateReported: "N/A",
    occupationCode: "N/A",
    income: "-",
    netGross: "-",
    monthlyAnnual: "-",
  };

  return (
    <div className="w-full max-w-5xl bg-white font-sans text-sm ">
      
      {/* 1. EMPLOYMENT INFORMATION SECTION */}
      {/* <div className="mb-1 px-2">
        <h3 className="text-base text-gray-600 mb-1 mt-1 uppercase tracking-wide">
          EMPLOYMENT INFORMATION:
        </h3>

        <div className="grid grid-cols-12 gap-2 mb-1 text-[10px] font-bold text-[#00a1de] uppercase">
          <div className="col-span-2">ACCOUNT TYPE</div>
          <div className="col-span-2">DATE REPORTED</div>
          <div className="col-span-2">OCCUPATION CODE</div>
          <div className="col-span-2">INCOME</div>
          <div className="col-span-2 leading-tight">NET / GROSS INCOME INDICATOR</div>
          <div className="col-span-2 leading-tight">MONTHLY / ANNUAL INCOME INDICATOR</div>
        </div>

        <div className="bg-[#e9ecef] grid grid-cols-12 gap-2 p-0.5 items-center font-bold text-black text-[10px]">
          <div className="col-span-2">{emp.accountType}</div>
          <div className="col-span-2">{formatDate(emp.dateReported)}</div>
          <div className="col-span-2">{emp.occupationCode}</div>
          <div className="col-span-2">{emp.income}</div>
          <div className="col-span-2">{emp.netGross}</div>
          <div className="col-span-2">{emp.monthlyAnnual}</div>
        </div>
      </div> */}

      {/* 2. SUMMARY TITLE */}
      <div className="px-2 mb-3">
        <h2 className="text-base text-gray-500 uppercase tracking-wide">
          SUMMARY:
        </h2>
      </div>

      {/* 3. ACCOUNT(S) SECTION */}
      <div className="mb-6 px-2">
        <h3 className="text-base text-[#00a1de] mb-3 uppercase tracking-wide">
          ACCOUNT(S):
        </h3>

        {/* Table Header */}
        <div className="grid grid-cols-12 gap-2 mb-1 text-[10px] font-bold text-[#00a1de] uppercase">
          <div className="col-span-2">ACCOUNT TYPE</div>
          <div className="col-span-3">ACCOUNTS</div>
          <div className="col-span-3">ADVANCES</div>
          <div className="col-span-2">BALANCES</div>
          <div className="col-span-2">DATE OPENED</div>
        </div>

        {/* Table Data Row */}
        <div className="bg-[#e9ecef] grid grid-cols-12 gap-2 p-1 items-start text-[10px] text-black">
          {/* Account Type */}
          <div className="col-span-2 font-bold">All Accounts</div>

          {/* Accounts Details */}
          <div className="col-span-3 flex flex-col ">
            <div className="-mb-2">
              <span className="font-normal">TOTAL:</span>
              <span className="font-bold">{accountStats.accounts.total}</span>
            </div>
            <div className="-mb-2">
              <span className="font-normal">OVERDUE:</span>
              <span className="font-bold">{accountStats.accounts.overdue}</span>
            </div>
            <div>
              <span className="font-normal">ZERO-BALANCE:</span>
              <span className="font-bold">{accountStats.accounts.zeroBalance}</span>
            </div>
          </div>

          {/* Advances Details */}
          <div className="col-span-3">
            <span className="font-normal">HIGH CR/SANC. AMT:</span>
            <span className="font-bold">{accountStats.advances.highSanctionedAmt}</span>
          </div>

          {/* Balances Details */}
          <div className="col-span-2 flex flex-col ">
            <div className="-mb-2">
              <span className="font-normal">CURRENT::</span>
              <span className="font-bold">{accountStats.balances.current}</span>
            </div>
            <div>
              <span className="font-normal">OVERDUE:</span>
              <span className="font-bold">{accountStats.balances.overdue}</span>
            </div>
          </div>

          {/* Date Opened Details */}
          <div className="col-span-2 flex flex-col ">
            <div className="-mb-2">
              <span className="font-normal">RECENT:</span>
              <span className="font-bold">{accountStats.openingDate.recent}</span>
            </div>
            <div>
              <span className="font-normal">OLDEST:</span>
              <span className="font-bold">{accountStats.openingDate.oldest}</span>
            </div>
          </div>
        </div>
      </div>

      {/* 4. ENQUIRIES SECTION */}
      <div className="px-2">
        <h3 className="text-base text-[#00a1de] mb-3 uppercase tracking-wide">
          ENQUIRIES:
        </h3>

        {/* Table Header */}
        <div className="grid grid-cols-12 gap-2 mb-1 text-[10px] font-bold text-[#00a1de] uppercase">
          <div className="col-span-2">ENQUIRY PURPOSE</div>
          <div className="col-span-2">TOTAL</div>
          <div className="col-span-2">PAST 30 DAYS</div>
          <div className="col-span-2">PAST 12 MONTHS</div>
          <div className="col-span-2">PAST 24 MONTHS</div>
          <div className="col-span-2">RECENT</div>
        </div>

        {/* Table Data Row */}
        <div className="bg-[#e9ecef] grid grid-cols-12 gap-2 p-1 items-center text-[10px] text-black">
          <div className="col-span-2 font-bold">All Enquiries</div>
          <div className="col-span-2 font-bold">{totalEnquiries}</div>
          <div className="col-span-2"></div>
          <div className="col-span-2"></div>
          <div className="col-span-2"></div>
          <div className="col-span-2"></div>
        </div>
      </div>

    </div>
  );
}